import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AuthApi } from '../../../api/AuthApi';
const initialState = {
  status: false,
  message: '',
  data: {},
  currentRequestId: undefined,
  loading: 'idle',
  error: null
};
export const confirmMail = createAsyncThunk(
  'auth/confirmMail',
  async (authData, { rejectWithValue, getState, requestId }) => {
    try {
      const test = await getState();
      const { currentRequestId, loading } = await getState().confirm_mail;
      if (loading !== 'pending' || requestId !== currentRequestId) return;
      const data = await AuthApi.confirmMail({ values: authData });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const confirmMailSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(confirmMail.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending';
          state.currentRequestId = action.meta.requestId;
          state.error = null;
        }
      })
      .addCase(confirmMail.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.data = action.payload;
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(confirmMail.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      });
  }
});

export default confirmMailSlice.reducer;
